import fetch from 'auth/FetchInterceptor';
import { toQueryParams } from 'constants/BankReconciliationConstant';

const BankReconciliationService = {};
const BasePath = '/bank-reconciliation';

export const BANK_RECONCILIATION_QUERY_KEY = 'bank_reconciliation';

BankReconciliationService.importStatement = function ({ paymentMethodId, file, closingBalance }) {
    const form = new FormData();
    form.append('payment_method_id', String(paymentMethodId));
    form.append('file', file);
    if (closingBalance !== undefined && closingBalance !== null && closingBalance !== '') {
        form.append('closing_balance', String(closingBalance));
    }
    return fetch({
        url: BasePath + '/import',
        method: 'Post',
        data: form,
        timeout: 180000,
        silentError: true,
    });
};

BankReconciliationService.listImports = function (params = {}) {
    return {
        queryKey: [BANK_RECONCILIATION_QUERY_KEY, 'imports', params],
        queryFn: () => fetch({
            url: BasePath + '/imports',
            method: 'Get',
            params: toQueryParams(params),
        })
    };
};

BankReconciliationService.listTransactions = function (params = {}) {
    return {
        queryKey: [BANK_RECONCILIATION_QUERY_KEY, 'transactions', params],
        queryFn: () => fetch({
            url: BasePath + '/transactions',
            method: 'Get',
            params: toQueryParams(params),
        })
    };
};

BankReconciliationService.getReviewCount = function () {
    return {
        queryKey: [BANK_RECONCILIATION_QUERY_KEY, 'review_count'],
        queryFn: () => fetch({
            url: BasePath + '/transactions',
            method: 'Get',
            params: toQueryParams({ status: ['suggested', 'flagged'], direction: ['credit'], page: 1, pageSize: 1 }),
            silentError: true,
        })
    };
};

BankReconciliationService.getTransaction = function (id) {
    return {
        queryKey: [BANK_RECONCILIATION_QUERY_KEY, 'transaction', id],
        queryFn: () => fetch({
            url: `${BasePath}/transactions/${id}`,
            method: 'Get',
        })
    };
};

BankReconciliationService.getSuggestions = function (id) {
    return {
        queryKey: [BANK_RECONCILIATION_QUERY_KEY, 'suggestions', id],
        queryFn: () => fetch({
            url: `${BasePath}/transactions/${id}/suggestions`,
            method: 'Get',
        })
    };
};

BankReconciliationService.match = function ({ id, creditRequestId }) {
    return fetch({
        url: `${BasePath}/transactions/${id}/match`,
        method: 'Post',
        data: { creditRequestId },
        silentError: true,
    });
};

BankReconciliationService.ignore = function ({ id, note }) {
    return fetch({
        url: `${BasePath}/transactions/${id}/ignore`,
        method: 'Post',
        data: note ? { note } : {},
        silentError: true,
    });
};

BankReconciliationService.restore = function ({ id }) {
    return fetch({
        url: `${BasePath}/transactions/${id}/restore`,
        method: 'Post',
        silentError: true,
    });
};

BankReconciliationService.rematch = function ({ paymentMethodId } = {}) {
    return fetch({
        url: BasePath + '/rematch',
        method: 'Post',
        data: paymentMethodId ? { payment_method_id: paymentMethodId } : {},
        timeout: 180000,
        silentError: true,
    });
};

BankReconciliationService.listUnmatchedRequests = function (paymentMethodId) {
    return {
        queryKey: [BANK_RECONCILIATION_QUERY_KEY, 'unmatched_requests', paymentMethodId ?? null],
        queryFn: () => fetch({
            url: BasePath + '/requests/unmatched',
            method: 'Get',
            params: toQueryParams({ payment_method_id: paymentMethodId }),
        })
    };
};

BankReconciliationService.listPayerAccounts = function (params = {}) {
    return {
        queryKey: [BANK_RECONCILIATION_QUERY_KEY, 'payer_accounts', params],
        queryFn: () => fetch({
            url: BasePath + '/payer-accounts',
            method: 'Get',
            params: toQueryParams(params),
        })
    };
};

BankReconciliationService.createPayerAccount = function (data) {
    return fetch({
        url: BasePath + '/payer-accounts',
        method: 'Post',
        data,
        silentError: true,
    });
};

BankReconciliationService.updatePayerAccount = function ({ id, data }) {
    return fetch({
        url: `${BasePath}/payer-accounts/${id}`,
        method: 'Patch',
        data,
        silentError: true,
    });
};

BankReconciliationService.deletePayerAccount = function (id) {
    return fetch({
        url: `${BasePath}/payer-accounts/${id}`,
        method: 'Delete',
        silentError: true,
    });
};

BankReconciliationService.getFeesReport = function (params = {}) {
    return {
        queryKey: [BANK_RECONCILIATION_QUERY_KEY, 'fees', params],
        queryFn: () => fetch({
            url: BasePath + '/fees',
            method: 'Get',
            params: toQueryParams(params),
        })
    };
};

BankReconciliationService.getSettings = function () {
    return {
        queryKey: [BANK_RECONCILIATION_QUERY_KEY, 'settings'],
        queryFn: () => fetch({
            url: BasePath + '/settings',
            method: 'Get',
        })
    };
};

BankReconciliationService.updateSettings = function (data) {
    return fetch({
        url: BasePath + '/settings',
        method: 'Put',
        data,
        silentError: true,
    });
};

export default BankReconciliationService;
